import React from 'react';
import PropTypes from 'prop-types';
import withIntl from '../../lib/withIntl';
import {TrayType} from '../../constants/dataEnum';

function TrayPreviewItem({deckValue, type, intl}) {
  const getTitle = () => {
    if (type === TrayType.NORMAL_CADDY && deckValue.id === 2) {
      return 'Caddy Insert';
    }
    if (type === TrayType.DOUBLE_CADDY && (deckValue.id === 1 || deckValue.id === 2)) {
      return `Caddy Insert ${deckValue.id}`;
    }

    if (type === TrayType.HIGH_VOLUME_CADDY && deckValue.id === 2) {
      return 'High Volume Caddy Insert';
    }

    return `Deck Insert ${deckValue.id}`;
  };

  const getClassName = () => {
    if (
      (type === TrayType.NORMAL_CADDY && deckValue.id === 2) ||
      (type === TrayType.DOUBLE_CADDY && (deckValue.id === 1 || deckValue.id === 2)) ||
      (type === TrayType.HIGH_VOLUME_CADDY && deckValue.id === 2)
    ) {
      return type;
    }

    return '';
  };

  return (
    <div className={`tray-preview-item ${deckValue.isSelected ? 'selected' : ''} ${getClassName()}`}>
      <div className={`tray-preview-item__label  ${getClassName()}`} />
      <div className="tray-preview-item__slot">{getTitle()}</div>
      <div className="tray-preview-item__value">
        <strong>X:</strong>
        <span>{deckValue.calibrationData.x}</span>
        <strong>mm</strong>
      </div>
      <div className="tray-preview-item__value">
        <strong>Y:</strong>
        <span>{deckValue.calibrationData.y}</span>
        <strong>mm</strong>
      </div>
      <div className="tray-preview-item__value">
        <strong>Z:</strong>
        <span>{deckValue.calibrationData.z}</span>
        <strong>mm</strong>
      </div>
      <div
        className={`tray-preview-item__status calibration-status ${deckValue.isCalibrated ? 'calibrated' : 'uncalibrated'}`}
      >
        {deckValue.isCalibrated
          ? intl.formatMessage({id: 'trayCalibrationContainer.trayStatus.calibrated'})
          : intl.formatMessage({id: 'trayCalibrationContainer.trayStatus.uncalibrated'})}
      </div>
    </div>
  );
}

TrayPreviewItem.propTypes = {
  deckValue: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  intl: PropTypes.any.isRequired,
};

export default withIntl(TrayPreviewItem);
